import { RootState } from "./store";
import { sendTrackingEvent } from "../utils/tracking";
import { AnyAction, Dispatch, MiddlewareAPI } from "redux";

const devLoggerMiddleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next: Dispatch) => (action: AnyAction) => {
  console.group(action.type);
  console.info("dispatching", action);
  console.log("previous state", store.getState());
  const result = next(action);
  console.log("next state", store.getState());
  console.groupEnd();
  return result;
};

const loggerMiddleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next: Dispatch) => (action: AnyAction) => {
  const prevState: RootState = store.getState();
  const result = next(action);
  const nextState: RootState = store.getState();
  if (!prevState.calculator.form.dirty && nextState.calculator.form.dirty) {
    sendTrackingEvent("tool_started");
  }
  if (action.type === "calculator/complete") {
    sendTrackingEvent("tool_completed");
  }
  return result;
};

export { devLoggerMiddleware, loggerMiddleware };
